<template>
  <div>
    <template>
      <el-row>
        <el-col :span="14">
          <el-table :data="configList"
                    stripe
                    style="width: 100%">

            <el-table-column label="开发配置"
                             width="350">
              <template slot-scope="scope">
                appKey: {{scope.row.appKey }}<br>
                appSecret: {{scope.row.appSecret }}
              </template>
            </el-table-column>
            <el-table-column label="用户信息">
              <template slot-scope="scope">
                手机号： {{scope.row.user && scope.row.user.mobile}}<br>
                用户名： {{scope.row.user && scope.row.user.name}}
              </template>
            </el-table-column>

            <el-table-column label="角色信息">
              <template slot-scope="scope">
                角色名： {{scope.row.role && scope.row.role.name}}
              </template>
            </el-table-column>

            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-link :underline="false"
                         @click="toEdit(scope.row)">编辑</el-link>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="9">
          <el-form ref="form"
                   :model="form"
                   label-width="80px">

            <el-form-item label="用户">
              <el-autocomplete v-model="temp"
                               :fetch-suggestions="querySearchAsync"
                               placeholder="请输入手机号"
                               @select="handleSelect"></el-autocomplete>
            </el-form-item>
            <template v-if="form.id">
              <el-form-item label="appKey">
                <el-input v-model="form.appKey"
                          :disabled="true">
                </el-input>
              </el-form-item>
              <el-form-item label="appSecret">
                <el-input v-model="form.appSecret">
                </el-input>
              </el-form-item>
            </template>
            <el-form-item label="角色">
              <el-select v-model="form.roleId"
                         placeholder="请选择">
                <el-option v-for="item in roleList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         @click="onSubmit">
                <template v-if="form.id">
                  修改
                </template>
                <template v-else>
                  添加
                </template>
              </el-button>
              <el-button @click="form={}"> 清空</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

    </template>
  </div>
</template>

<script>

import axios from 'axios'

export default {
  name: 'ele',
  data: function () {
    return {
      roleList: [],
      configList: [],
      form: {},
      temp: null,
      timeout: null
    }
  },
  filters: {
    typeFilter: function (v) {
      switch (v) {
        case 'SXN':
          return '雪宁'
        case 'LYD':
          return '彦东'
        case 'KBX':
          return '保星'
        default:
          return '未知'
      }
    }
  },

  computed: {

  },
  methods: {
    toEdit (row) {
      this.form = row
      let user = row.user
      this.form.userId = user.id
      this.temp = user.mobile + '-' + user.name
    },
    getRoleList () {
      let _this = this
      axios.get('/api/web/admin/roleList').then(resp => {
        _this.roleList = resp.data
      })
    },

    querySearchAsync (query, cb) {
      if (!query) {
        return
      }
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        axios.post('/api/web/admin/searchUser', { 'mobile': query }).then(resp => {
          cb(resp.data.map(m => { return { 'id': m.id, 'value': m.mobile + '-' + m.name, 'label': m.name } }))
        })
      }, 3000 * Math.random())
    },
    handleSelect (item) {
      this.form.userId = item.id
    },
    getList () {
      let _this = this
      axios.get('/api/web/admin/devConfigs').then(resp => {
        _this.configList = resp.data
      })
    },
    onSubmit () {
      let _this = this
      axios.post('/api/web/admin/createConfig', this.form).then(resp => {
        _this.getList()
      })
    }
  },

  mounted () {
    this.getList()
    this.getRoleList()
  }
}
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/app/developer/config.vue